import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule }    from '@angular/http';
import { FormsModule } from '@angular/forms';

import { Ng2Bs3ModalModule } from 'ng2-bs3-modal/ng2-bs3-modal';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AttendanceStudentComponent } from './attendance-student/attendance-student.component';
import { AppRoutingModule } from './app-routing.module';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';

import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import  { InMemoryDataService } from "./in-memory-data.service";
import { RegisterComponent } from './register/register.component';
import { LoginComponent } from './login/login.component';
import { AttendanceStaffComponent } from './attendance-staff/attendance-staff.component';

import {
  AuthenticationService, SchoolService, StudentService, AttendStudentService, AttendStaffService, StaffService
 } from './Service/index';
import { AuthGuard } from './Guards/index';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AttendanceStudentComponent,
    RegisterComponent,
    LoginComponent,
    AttendanceStaffComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    FormsModule,
    AppRoutingModule,
    Ng2Bs3ModalModule,
    // InMemoryWebApiModule.forRoot(InMemoryDataService),
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    AuthGuard,
    StudentService,
    AttendStudentService,
    AuthenticationService,
    SchoolService,
    StaffService,
    AttendStaffService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/hihoo/ibilling/attendence/public/src/app/app.module.ts